import React, { Component } from 'react';
import EditMember from '../CommonComponent/EditMember';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { ActiveListsetEdit } from '../../Redux/action/memberAction';
import AddnewRoles from './AddnewRoles';
import axios from 'axios';
import { dataUser } from '../Helpers/util';
import mixpanel from 'mixpanel-browser';
import moment from 'moment';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';
import AntDTable from '../Common/AntDTable/AntDTable';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
var FormData = require('form-data');

class MainRoleTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pgno: this.props.pg,
      showEditRoles: false,
      row: this.props.rw,
      setIndex: 0,
      items: {},
      company_id: UserObj ? UserObj.company_id : null,
      loader: false,
      orgRole: [],
      roleData: null,
      rolestatus: null,
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      sortArrow: 'down',
      sortCreatedArrow: 'down',
      currentPage: 1,
      pageSize: this.props.rw || 25,

      sorterState: null,
    };

    this.editRolesRef = React.createRef();
  }

  componentDidMount = e => { };

  changeforward = () => {
    this.setState({
      setIndex: this.state.setIndex + 1,
      loader: true,
    });
    var itemIndex = this.state.items[this.state.setIndex + 1];
    var singleId = itemIndex.rec_id;
    let parm = {
      rec_id: singleId,
    };
    this.props.ActiveListsetEdit(parm);
  };



  componentDidUpdate(prevProps) {
    if (
      prevProps.pg !== this.props.pg ||
      prevProps.rw !== this.props.rw
    ) {
      this.setState({
        currentPage: this.props.pg,
        pageSize: this.props.rw,
      });
    }
  }
  changebackformward = () => {
    this.setState({
      setIndex: this.state.setIndex - 1,
      loader: true,
    });
    var itemIndex = this.state.items[this.state.setIndex - 1];
    var singleId = itemIndex.rec_id;
    let parm = {
      rec_id: singleId,
    };
    this.props.ActiveListsetEdit(parm);
  };

  closeEditRoles = () => {
    this.setState({ showAddRoles: false });
  };

  getColumns = () => [
    {
      title: 'ROLE NAME',
      dataIndex: 'role_name',
      key: 'role_name',   // ✅ ADD THIS
      sorter: true,
      render: text => (
        <span style={{ fontWeight: 600 }} className="capitalCase">
          {text}
        </span>
      ),
    },
    {
      title: 'DATE CREATED',
      dataIndex: 'added_at',
      key: 'added_at',   // ✅ ADD THIS
      sorter: true,
      render: val => moment.unix(val).format('YYYY-MM-DD HH:mm:ss'),
    },

    {
      title: 'CREATED BY',
      render: record => `${record.added_by_fname} ${record.added_by_lname}`,
    },
    {
      title: 'LAST UPDATED',
      dataIndex: 'updated_at',
      render: val =>
        val ? moment.unix(val).format('YYYY-MM-DD HH:mm:ss') : '-',
    },
    {
      title: 'UPDATED BY',
      render: record =>
        record.updated_by_fname
          ? `${record.updated_by_fname} ${record.updated_by_lname}`
          : '-',
    },
    {
      title: 'STATUS',
      dataIndex: 'role_status',
      render: val =>
        val === '2' ? (
          <span className="SwTextDanger SwTextSmall">nactive</span>
        ) : (
          <span className="text-success">Active</span>
        ),
    },
    {
      title: 'PERMISSIONS',
      render: record => (
        <a
          role="button"
          onClick={() => {
            this.editClick();
            this.setState({
              showEditRoles: true,
              roleData: record,
              rolestatus: record.role_status,
            });
          }}
        >
          <i className="fa fa-external-link-square" />
        </a>
      ),
    },
  ];

  btnClick() {
    mixpanel.track('Role Management Page View', {
      PageName: 'Roles',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Roles',
    });
  }

  editClick() {
    mixpanel.track('Role Management Edit', {
      PageName: 'Roles',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Roles',
    });
  }

  sendId = (list, status) => {
    this.setState({
      roleData: list,
      rolestatus: status,
    });
  };

  handleRoleSuccess = message => {
    // 1️⃣ show toast (parent stays mounted)
    toast.success(message, { autoClose: 3000 });

    // 2️⃣ close OffCanvas AFTER toast
    setTimeout(() => {
      this.setState({ showEditRoles: false });
    }, 3000);

    // 3️⃣ reload AFTER toast
    setTimeout(() => {
      window.location.reload();
    }, 3300);
  };

  componentDidMount() {
    this.btnClick();
  }

  componentWillReceiveProps(props) {
    if (props.activeUserList.userList != 0) {
      this.setState({
        items:
          props.activeUserList.userList && props.activeUserList.userList.list,
        loader: false,
      });
    }
  }

  handleArrow = arrowValue => {
    this.setState({
      sortArrow: arrowValue,
    });
    if (arrowValue == 'up') this.props.doIt('name');
    if (arrowValue == 'down') this.props.doIt('name_desc');
  };

  handleArrow2 = arrowValue => {
    this.setState({
      sortCreatedArrow: arrowValue,
    });
    if (arrowValue == 'up') this.props.doIt('date');
    if (arrowValue == 'down') this.props.doIt('');
  };
  render() {
    const Roles = this.state.userRole.find(
      element => element.service_id == '13',
    );
    const userRole = this.state.orgRole;

    return (
      <>
        {(Roles && Roles.role_for_write == '1' ? (
          true
        ) : (
          false
        )) ? (
          <SwOffCanvas
            show={this.state.showEditRoles}
            onClose={() => this.setState({ showEditRoles: false })}
            title="Edit Roles Details"
            placement="end"
            backdrop="static"
            keyboard={false}
            footer={
              <div className="pull-right">
                <SwButton
                  variant="dark-outline"
                  onClick={() => this.editRolesRef.current?.reload()}
                >
                  Reset
                </SwButton>

                <SwButton
                  variant="primary"
                  className="ml10"
                  onClick={e =>
                    this.editRolesRef.current?.addroleSubmitHandler(e)
                  }
                >
                  Submit Role
                </SwButton>
              </div>
            }
          >
            {this.state.rolestatus ? (
              <AddnewRoles
                rolestatus={this.state.rolestatus}
                roleData={this.state.roleData}
                ref={this.editRolesRef}
                onClose={this.closeEditRoles}
                onSuccess={this.handleRoleSuccess}
              />
            ) : null}
          </SwOffCanvas>
        ) : (
          ''
        )}
        <div className="">
          <AntDTable
            size='small'
            columns={this.getColumns()}
            dataSource={this.props.roleList || []}
            rowKey="rec_id"
            loading={this.props.loading}
            pagination
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            totalRecords={this.props.totalRole || 0}
            showTotal
            onPageChange={(page, size) => {
              this.setState({
                currentPage: page,
                pageSize: size,
              });

              // 🔥 Call parent
              if (this.props.onPageChange) {
                this.props.onPageChange(page, size);
              }
            }}
            onChange={(pagination, filters, sorter) => {
              this.setState({
                sorterState: sorter,
                currentPage: pagination.current,
                pageSize: pagination.pageSize,
              });

              if (this.props.doIt && sorter?.columnKey) {
                const order = sorter.order === 'ascend' ? 'asc' : 'desc';

                if (sorter.columnKey === 'role_name') {
                  this.props.doIt(order === 'asc' ? 'name' : 'name_desc');
                }

                if (sorter.columnKey === 'added_at') {
                  this.props.doIt(order === 'asc' ? 'date' : 'date_desc');
                }

              }
            }}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  activeUserList: state.activeUserList,
});
const mapActionsToProps = {
  ActiveListsetEdit,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(MainRoleTable);
